module.exports = __webpack_public_path__ + "0e97ef5888c9240133dc9a9ab34c9760.png";